const normalize = (value) =>
  value === undefined || value === null || value === '' ? '' : value

export default normalize
